import { IInfiniteData } from '../../../../types';

import {
  IInboundHistoryListResponse,
  IInboundItemDetail,
  HistoryType,
} from '../../../types';

/**
 * Format the response of the inbound history list items.
 */
export function formatInboundHistoryListResponse(
  data: IInfiniteData<IInboundHistoryListResponse> | undefined
): IInboundHistoryListResponse {
  if (!data?.pages || data.pages.length === 0) {
    return {
      historyList: [],
      total: 0,
      inboundDetails: null,
      filter: [],
    };
  }

  let total = 0;
  let inboundDetails: IInboundItemDetail | null = null;
  let filter: HistoryType[] = [];

  const historyList = data.pages.flatMap((page) => {
    total = page?.total || 0;
    inboundDetails = page?.inboundDetails || null;
    filter = page?.filter || [];

    return page?.historyList || [];
  });

  return { historyList, total, inboundDetails, filter };
}
